
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"24","cy":"24","r":"23.25","fill":"#5EA9FF","stroke":"#fff","stroke-width":"1.5"}}),_c('g',{attrs:{"clip-path":"url(#clip0_9157_47254)"}},[_c('path',{attrs:{"d":"M17.332 21.333L14.665 24l2.667 2.666","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})]),_c('g',{attrs:{"clip-path":"url(#clip1_9157_47254)"}},[_c('path',{attrs:{"d":"M30.666 26.668l2.667-2.667-2.667-2.666","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_9157_47254"}},[_c('path',{attrs:{"fill":"#fff","transform":"rotate(90 1.332 20)","d":"M0 0h10.667v10.667H0z"}})]),_c('clipPath',{attrs:{"id":"clip1_9157_47254"}},[_c('path',{attrs:{"fill":"#fff","transform":"rotate(-90 28 1.334)","d":"M0 0h10.667v10.667H0z"}})])])])
          )
        }
      }
    